import { Flex } from '@chakra-ui/react';
import { Controller, Control } from 'react-hook-form';
import { FormFeedback, Select } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

const AUTHORS_VISIBILITY_FIELD_KEYS = new Set([
  'orcidField',
  'affiliationField',
  'contributionsField',
  'contributionDegreeField'
]);

const AUTHORS_VISIBILITY_OPTIONS = ['optional', 'mandatory', 'hidden'];

type Props = {
  fieldKey: string;
  fieldLabel: string;
  control: Control<FieldFormValues>;
  validationError?: { message?: string };
  isFormDisabled: boolean;
};

export const isAuthorsVisibilityFieldKey = (key: string) =>
  AUTHORS_VISIBILITY_FIELD_KEYS.has(key);

const AuthorsVisibilitySelectField: React.FC<Props> = ({
  fieldKey,
  fieldLabel,
  control,
  validationError,
  isFormDisabled
}) => {
  return (
    <Controller
      name={`validationValues.${fieldKey}` as never}
      control={control}
      render={({ field }) => {
        const rawValue = String(field.value ?? '');
        const normalizedValue = rawValue.trim().toLowerCase();
        const selectedValue = AUTHORS_VISIBILITY_OPTIONS.includes(
          normalizedValue
        )
          ? normalizedValue
          : rawValue;

        return (
          <Flex direction="column" gap={2}>
            <FieldLabel label={fieldLabel} subText="" isRequired={false} />
            <Select
              name={field.name}
              value={selectedValue}
              onChange={e => field.onChange(e.target.value)}
              isInvalid={Boolean(validationError)}
              isReadOnly={isFormDisabled}
            >
              <option value="">Select an option</option>
              {AUTHORS_VISIBILITY_OPTIONS.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
            {validationError ? (
              <FormFeedback variant="error">{validationError.message}</FormFeedback>
            ) : null}
          </Flex>
        );
      }}
    />
  );
};

export default AuthorsVisibilitySelectField;
